import _ from 'lodash'
import Vue from 'vue'
import VueRouter from 'vue-router'
import Meta from 'vue-meta'
import App from './App.vue'
import store from '@/vuex/store'
// import VueSocketIO from 'vue-socket.io'
import Settings from '@/config/Settings'
import { mappingRoutes } from '@/Route.js'
import Translation from '@/core/mixins/Translation'
import LangMixin from '@/core/mixins/Lang'
import VueClipboard from 'vue-clipboard2'
import '@/core/js/Copyright'

import VueGeolocation from 'vue-browser-geolocation'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faCheck } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faCheck)

import isMobile from 'ismobilejs'

Vue.use(VueRouter)
Vue.use(Meta,{ keyName: 'head' })
Vue.mixin(Translation)
Vue.use(VueClipboard)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.config.productionTip = false
Vue.use(VueGeolocation)

import * as VueGoogleMaps from 'vue2-google-maps'
// Vue.use(VueGoogleMaps, {
//     load: {
//         key: 'AIzaSyCtHkUR3tTBnj9EgGtNCyMj17u6FkFqmLc',
//         language: 'fr'
//     }
// })

const routes = [
    // { id: 'home', name: 'home', component: 'Experience', fr: 'artiste/', en: 'home/' },
    { 
        id: 'experience', 
        name: 'experience', 
        component: 'Experience', 
        fr: "/fr/:id?",
        en: "/:id?"
        // fr: "/artiste/:id?",
        // en: "/artist/:id?"
    },
]

const router = new VueRouter({
    mode: 'history',
    routes: mappingRoutes(routes)
})


console.log(router);

new Vue({
    router,
    store,
    mixins: [ LangMixin ],
    head() {
        return {
            htmlAttrs: { lang: this.lang }
        }
    },
    data: () => ({
        width: window.innerWidth,
        height: window.innerHeight,
        isDev: process.env.NODE_ENV !== 'production',
        isProd: process.env.NODE_ENV === 'production',
        isDesk: window.innerWidth >= 1024 ? true : false
    }),
    beforeCreate() {
        this.$store.commit('app/LANG_CHANGED', this.$route.meta.lang)
        this.$store.commit('app/SET_FROM_ROUTE', this.$route)
        this.$store.commit('app/SET_TO_ROUTE', this.$route)
    },
    created() {
        this.$sizes =  {
            phone: 767,
            tabletPortrait: 768,
            tablet: 1024,
        }
        window.addEventListener('resize', this.onResize)

        // window.addEventListener('mousewheel', this.onWheel)

        // Vue.use(VueGoogleMaps, {
        //     load: {
        //         //  key: 'AIzaSyCtHkUR3tTBnj9EgGtNCyMj17u6FkFqmLc',
        //         key : 'AIzaSyBWNTdVDbIdM-VFlh980UcOGsrpQ-t9Dzc',
        //         language: 'fr'
        //     }
        // })

    },
    mounted() {
        this.onResize()
    },
    methods: {
        onWheel(evt) {
            const speed = 0.5
            const scrollDistance = 20
            const delta = evt.wheelDelta/20 || -evt.detail/4
            const scr = window.scrollY
            const fn = scr - parseInt(delta*scrollDistance)
            if(this.$smooth) this.$smooth.kill()
            // this.$smooth = TweenMax.to(window, speed, { scrollTo: fn,  ease: Cubic.easeOut, autoKill: true, overwrite: true })
        },

        onResize() {
            this.width = window.innerWidth
            this.height = window.innerHeight
        },
        below(type) { return this.width <= this.$sizes[type] },
        above(type) { return this.width >= this.$sizes[type] }
    },
    render: h => h(App)
}).$mount('#app')


